module.exports = __webpack_public_path__ + "img/icon-checkt-select.567292a3.svg";